import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 6v6a3 3 0 0 0 3 3h10l-4 -4m0 8l4 -4","key":"svg-0"}]]

/**
 * IconCornerDownRight
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY29ybmVyLWRvd24tcmlnaHQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTYgNnY2YTMgMyAwIDAgMCAzIDNoMTBsLTQgLTRtMCA4bDQgLTQiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/corner-down-right
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCornerDownRight = createReactComponent('outline', 'corner-down-right', 'CornerDownRight', __iconNode);

export default IconCornerDownRight;